import { PrintViewPage } from '../PrintView/PrintViewPage'

import { getPrintViewPath } from './paths'

export const routes = [
  {
    path: getPrintViewPath(':id'),
    component: PrintViewPage,
    exact: true
  }
]
